module.exports = __webpack_public_path__ + "static/media/report1.73bebcc2.png";